import * as $http from 'axios'

export default {
    all: () => $http.get('v2/auto_texts'),
    post: autoText => $http.post('v2/auto_texts', autoText),
    put: autoText => $http.put(`v2/auto_texts/${autoText.id}`, autoText),
    delete: autoTextId => $http.delete(`v2/auto_texts/${autoTextId}`),
}
